import { PackingTourSteps } from "../../components/TourGuide/tourGuideData";
import { useEffect, useRef, useState } from "react";
import {
  LiaSearchSolid,
} from "react-icons/lia";
import { MdClose, MdPrint } from "react-icons/md";
import { packingEntryAPI } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import ErrorModal from "../../common/CustomModel";
import { HiOutlinePlus } from "react-icons/hi";
import PackingForm from "./PackingForm";
import { RegistryHeader, CalculationFooter } from "../../common/Shared";
import { Info } from "lucide-react";
import { TourGuide } from "../../components/TourGuide/TourGuide";

const Packing = () => {
  const today = new Date().toISOString()?.split("T")[0];
  const [searchQuery, setSearchQuery] = useState("");
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);

  const [isTourOpen, setIsTourOpen] = useState(false);

  useEffect(() => {
    const hasSeenTour = localStorage.getItem("aluex_packing_tour_seen");
    if (!hasSeenTour) {
      const timer = setTimeout(() => {
        setIsTourOpen(true);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleTourComplete = () => {
    localStorage.setItem("aluex_packing_tour_seen", "true");
  };


  const [errorMessage, setErrorMessage] = useState("");
  const [errorSubMessage, setErrorSubMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [selectedPackingData, setSelectedPackingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isPackingData, setisPackingData] = useState([]);
  const [isAgingDoneData, setIsAgingDoneData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [formData, setFormData] = useState({
    bundle_No: null,
    packing_Date: today,
    order_No: "",
    batch_Id: "",
    die_Id: "",
    casting_No: "",
    dieNumber: "",
    cut_Length: "",
    wt_12_FT: "",
    wt_Cut_Length: "",
    pcs: "",
    total_Weight: "",
    series_Name: "",
    remark: "",
    // bundle_Pcs: "",
    // bundle_Weight: "",
    unit_Conv_Id: "",
    final_CutLength_weight: "",
  });
  const pageSize = 50;
  const [isActiveTab, setIsActiveTab] = useState("aging-done");
  const [selectedAgingNo, setSelectedAgingNo] = useState([]);
  const [adding, setAdding] = useState(false);
  const [selectedBundles, setSelectedBundles] = useState([]);
  const tableScrollRef = useRef(null);
  const isFetchingRef = useRef(false);
  const [packingHasMore, setPackingHasMore] = useState(true);
  const [agingHasMore, setAgingHasMore] = useState(true);
  const [packingPage, setPackingPage] = useState(1);
  const [agingPage, setAgingPage] = useState(1);

  const fetchPackingData = async (page = 1) => {
    setLoading(true);
    try {
      const res = await packingEntryAPI.getAllPackingEntry(page, pageSize);
      setisPackingData((prev) => {
        return page === 1 ? res.data || [] : [...prev, ...(res.data || [])];
      });

      if (!res.data || res.data.length < pageSize) {
        setPackingHasMore(false);
      }
      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching sales order master data", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(isPackingData);
    } else {
      const filtered = isPackingData.filter((d) =>
        d.status_Name.toLowerCase().includes(searchQuery.toLowerCase()),
      );
      setFilteredData(filtered);
    }
  }, [searchQuery, isPackingData]);

  const handleEdit = async (row) => {
    const bundle_No = row?.bundle_No;
    setLoading(true);
    try {
      const res = await packingEntryAPI.getById(bundle_No);
      const doc = res?.data ?? res;
      setSelectedPackingData(doc);
      setIsEditing(true);
      setIsModelOpen(true);
    } catch (err) {
      notify("Failed to fetch packing entry details", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (data, id) => {
    setIsSaving(true);
    try {
      const finalData = {
        bundle_No: data.bundle_No || "0",
        packing_Date: data.packing_Date,
        die_Id: data.die_Id,
        order_No: Number(data.order_No),
        dieNumber: data.dieNumber,
        batch_Id: data.batch_Id,
        casting_No: data.casting_No,
        cut_Length: Number(data.cut_Length),
        wt_12_FT: parseFloat(data.wt_12_FT || 0),
        wt_Cut_Length: parseFloat(data.wt_Cut_Length || 0),
        pcs: Number(data.pcs || 0),
        total_Weight: parseFloat(data.total_Weight || 0),
        series_Name: data.series_Name,
        remark: data.remark,
        // bundle_Pcs: data.bundle_Pcs,
        // bundle_Weight: data.bundle_Weight,
        unit_Conv_Id: data.unit_Conv_Id,
        final_CutLength_weight: data.final_CutLength_weight,
      };

      await packingEntryAPI.saveOrUpdate(finalData);
      notify(id && id !== "0" ? "Updated successfully" : "Added successfully", "success");
      setPackingPage(1);
      setAgingPage(1);
      fetchPackingData(1);
      fetchAgingDoneData(1);
      setIsModelOpen(false);
      setFormData({
        bundle_No: "0",
        packing_Date: today,
        order_No: "",
        dieNumber: "",
        die_Id: "",
        batch_Id: "",
        casting_No: "",
        cut_Length: "",
        wt_12_FT: "",
        wt_Cut_Length: "",
        pcs: "",
        total_Weight: "",
        series_Name: "",
        remark: "",
        // bundle_Pcs: "",
        // bundle_Weight: "",
        unit_Conv_Id: "",
        final_CutLength_weight: "",
      });
      setIsEditing(false);
    } catch (error) {
      notify("Failed to submit form", "error");
      setErrorMessage("Submission failed");
      setErrorSubMessage("Please check your input or try again.");
      setErrorModalOpen(true);
    } finally {
      setIsSaving(false);
    }
  };

  const fetchAgingDoneData = async (page = 1) => {
    setLoading(true);
    try {
      const res = await packingEntryAPI.getAllAgingDone(page, pageSize);
      setIsAgingDoneData((prev) => {
        return page === 1 ? res.data || [] : [...prev, ...(res.data || [])];
      });

      if (!res.data || res.data.length < pageSize) {
        setAgingHasMore(false);
      }
      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching location data", "error");
    }
    setLoading(false);
  };

  const handleTabChange = (tab) => {
    setIsActiveTab(tab);
    if (tab === "aging-done") {
      setPackingPage(1);
      setIsAgingDoneData([]);
      setAgingHasMore(true);
    } else {
      setPackingPage(1);
      setisPackingData([]);
      setPackingHasMore(true);
    }
  };

  useEffect(() => {
    if (isActiveTab === "aging-done") fetchAgingDoneData(agingPage);
  }, [agingPage, isActiveTab]);

  useEffect(() => {
    if (isActiveTab === "packing") fetchPackingData(packingPage);
  }, [packingPage, isActiveTab]);

  useEffect(() => {
    const el = tableScrollRef.current;
    if (!el) return;

    const onScroll = () => {
      if (loading || isFetchingRef.current) return;

      const { scrollTop, clientHeight, scrollHeight } = el;

      if (scrollHeight - scrollTop <= clientHeight + 100) {
        isFetchingRef.current = true;

        if (isActiveTab === "aging-done" && agingHasMore) {
          setAgingPage((p) => p + 1);
        }

        if (isActiveTab === "packing" && packingHasMore) {
          setPackingPage((p) => p + 1);
        }
      }
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, [isActiveTab, loading, packingHasMore, agingHasMore]);

  const columns = [
    {
      key: "select",
      align: "center",
      disableSort: true,
      label: (
        <input
          type="checkbox"
          checked={
            isAgingDoneData.length > 0 &&
            isAgingDoneData.every((row) => selectedAgingNo.includes(Number(row.seq_No)))
          }
          onChange={(e) => {
            if (e.target.checked) {
              const allIds = isAgingDoneData.map((row) => Number(row.seq_No));
              setSelectedAgingNo(allIds);
            } else {
              setSelectedAgingNo([]);
            }
          }}

          className="w-4 h-4 text-primary cursor-pointer"
        />
      ),
      render: (_v, row) => {
        const id = Number(row.seq_No);
        const isChecked = selectedAgingNo.includes(id);
        return (
          <input
            type="checkbox"
            checked={isChecked}

            onChange={(e) => {
              if (e.target.checked) {
                setSelectedAgingNo((prev) => [...prev, id]);
              } else {
                setSelectedAgingNo((prev) =>
                  prev.filter((item) => item !== id),
                );
              }
            }}
            className="w-4 h-4 text-primary cursor-pointer"
          />
        );
      },
    },
    { key: "order_No", label: "ORDER NO", align: "center" },
    { key: "batch_Id", label: "BATCH NO", align: "center" },
    { key: "dieNumber", label: "DIE NO", align: "center" },
    { key: "cut_Length", label: "CUT LENGTH", align: "center" },
    { key: "quantity", label: "PCS", align: "center" },
    { key: "pending_Pcs", label: "PENDING PCS", align: "center" },
    { key: "total_Weight", label: "TOTAL WEIGHT", align: "center" },
  ];

  const handleAddPacking = async () => {
    if (!selectedAgingNo) {
      notify("Please select one Aging-Done row.", "warning");
      return;
    }
    setAdding(true);
    try {
      const resp = await packingEntryAPI.AddToPacking(
        Number(selectedAgingNo[0]),
      );
      const x = Array.isArray(resp) ? resp[0] : resp;
      const init = {
        bundle_No: "0",
        packing_Date: today,
        order_No: x?.order_No ?? "",
        die_Id: x?.die_Id ?? null,
        dieNumber: x?.dieNumber ?? "",
        cut_Length: x?.cut_Length ?? "",
        batch_Id: x?.batch_Id ?? "",
        casting_No: x?.casting_No ?? "",
        total_Weight: x?.total_Weight ?? "",
        wt_12_FT: "",
        wt_Cut_Length: x?.cut_Length ?? "",
        pcs: "",
        series_Name: x?.series_Name ?? "",
        remark: "",
        // bundle_Pcs: "",
        // bundle_Weight: "",
        unit_Conv_Id: "",
        final_CutLength_weight: "",
      };
      setSelectedPackingData(init);
      setIsActiveTab("packing");
      setIsModelOpen(true);
      setIsEditing(false);
      setSelectedAgingNo([]);
    } catch (e) {
      notify(
        e?.response?.data?.message || e?.message || "Failed to Add to Packing",
        "error",
      );
    } finally {
      setAdding(false);
    }
  };

  const handlePrint = async () => {
    if (selectedBundles.length === 0) {
      notify("Please select at least one bundle to print", "warning");
      return;
    }

    setLoading(true);
    try {
      const payload = { bundleNos: selectedBundles };
      const res = await packingEntryAPI.packingBundles(payload);

      const blob = new Blob([res.data], { type: "application/pdf" });

      const pdfUrl = URL.createObjectURL(blob);
      window.open(pdfUrl, "_blank");
    } catch (error) {
      notify("Failed to print selected bundles", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col h-full bg-white font-plus relative">
      {loading && <Loader centered />}
      <RegistryHeader title="Packing Plan View">
        <div className="flex bg-gray-100 p-1 rounded-sm gap-1 shrink-0" data-tour="packing-tabs">
          <button
            onClick={() => handleTabChange("aging-done")}
            className={`px-6 py-2 text-[10px] font-black uppercase tracking-widest transition-all ${isActiveTab === "aging-done"
              ? "bg-primary text-white  #3F80F7]/20"
              : "text-gray-400 hover:text-gray-600 hover:bg-gray-200/50"
              }`}
          >
            Aging Done
          </button>
          <button
            onClick={() => handleTabChange("packing")}
            className={`px-6 py-2 text-[10px] font-black uppercase tracking-widest transition-all ${isActiveTab === "packing"
              ? "bg-primary text-white  #3F80F7]/20"
              : "text-gray-400 hover:text-gray-600 hover:bg-gray-200/50"
              }`}
          >
            Packing Entry
          </button>
        </div>

        <div className="relative w-full sm:w-80 group" data-tour="packing-search">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none group-focus-within:text-primary">
            <LiaSearchSolid size={18} className="text-gray-400 transition-colors" />
          </div>
          <input
            type="text"
            className="block w-full pl-12 pr-10 py-2.5 bg-gray-50 border border-gray-200 text-gray-900 text-[11px] font-black uppercase tracking-[2px] focus:border-primary focus:bg-white focus:outline-none transition-all placeholder:text-gray-300"
            placeholder={
              isActiveTab === "aging-done"
                ? "Search by order, customer..."
                : "Search packing details..."
            }
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          {searchQuery && (
            <button
              onClick={() => setSearchQuery("")}
              className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-red-500 transition-colors"
            >
              <MdClose size={18} />
            </button>
          )}
        </div>

        <button
          onClick={() => setIsTourOpen(true)}
          className="flex items-center gap-2 px-4 py-2.5 h-[42px] text-[10px] font-black uppercase tracking-widest text-primary hover:bg-primary/5 transition-colors border border-primary bg-white shrink-0"
          title="Start Onboarding Tour"
        >
          <Info size={14} className="shrink-0" />
          Guide
        </button>

        {isActiveTab === "aging-done" ? (
          <button
            onClick={handleAddPacking}
            disabled={adding || selectedAgingNo.length === 0}
            className={`h-[42px] px-8 text-[10px] font-black uppercase tracking-[3px] transition-all flex items-center gap-3 border ${selectedAgingNo?.length > 0
              ? "bg-gray-900 text-white border-gray-900 hover:bg-black font-black cursor-pointer"
              : "bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed font-black"
              }`}
            data-tour="add-packing-btn"
          >
            {adding ? (
              <div className="w-4 h-4 border-2 border-white/20 border-t-white animate-spin rounded-full"></div>
            ) : (
              <HiOutlinePlus size={16} className={selectedAgingNo?.length > 0 ? "text-primary" : "text-gray-300"} />
            )}
            Add Packing ({selectedAgingNo.length})
          </button>
        ) : (
          <button
            onClick={handlePrint}
            disabled={selectedBundles.length === 0 || loading}
            className={`h-[42px] px-8 text-[10px] font-black uppercase tracking-[3px] transition-all flex items-center gap-3 border ${selectedBundles.length > 0
              ? "bg-gray-900 text-white border-gray-900 hover:bg-black font-black cursor-pointer"
              : "bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed font-black"
              }`}
            data-tour="print-sticker-btn"
          >
            {loading ? (
              <div className="w-4 h-4 border-2 border-white/20 border-t-white animate-spin rounded-full"></div>
            ) : (
              <MdPrint size={16} className={selectedBundles.length > 0 ? "text-primary" : "text-gray-300"} />
            )}
            Print Sticker ({selectedBundles.length})
          </button>
        )}
      </RegistryHeader>

      <div className="px-8 pt-0 pb-4 flex-1 overflow-hidden flex flex-col bg-white">
        <div
          ref={tableScrollRef}
          className="relative flex-1 overflow-auto border border-gray-200 bg-white"
          data-tour="packing-table"
        >
          {isActiveTab === "aging-done" && (
            <div className="min-w-max">
              <Table
                columns={columns}
                data={isAgingDoneData}
                showActions={false}
                onRowClick={(row) => setSelectedAgingNo(Number(row.seq_No))}
                tableClassName="text-[13px]"
              />
            </div>
          )}
          {isActiveTab === "packing" && (
            <div className="min-w-max bg-white">
              <Table
                columns={[
                  {
                    key: "select",
                    disableSort: true,
                    align: "center",
                    className: "w-12 border-r border-gray-100",
                    label: (
                      <input
                        type="checkbox"
                        checked={
                          isPackingData.length > 0 &&
                          isPackingData.every((row) => selectedBundles.includes(row.bundle_No))
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            const allIds = isPackingData.map((row) => row.bundle_No);
                            setSelectedBundles(allIds);
                          } else {
                            setSelectedBundles([]);
                          }
                        }}
                        className="w-4 h-4 text-primary cursor-pointer"
                      />
                    ),
                    render: (val, row) => (
                      <input
                        type="checkbox"
                        checked={selectedBundles.includes(row.bundle_No)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedBundles((prev) => [...prev, row.bundle_No]);
                          } else {
                            setSelectedBundles((prev) => prev.filter((id) => id !== row.bundle_No));
                          }
                        }}
                        className="w-4 h-4 text-primary cursor-pointer"
                      />
                    )
                  },
                  { key: "bundle_No", label: "BUNDLE NO", align: "center", className: "font-black text-gray-900 border-r border-gray-100" },
                  { key: "dieNumber", label: "DIE NO", align: "left", className: "font-black text-primary border-r border-gray-100" },
                  { key: "series_Name", label: "SERIES", align: "left", className: "border-r border-gray-100 font-black text-gray-800 text-[11px] uppercase tracking-wider" },
                  { key: "profile_Name", label: "PROFILE", align: "left", className: "border-r border-gray-100 text-[10px] text-gray-400 font-medium uppercase" },
                  { key: "wt_Cut_Length", label: "FINAL CUT LENGHT", align: "right", className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter", render: (val, row) => row.wt_Cut_Length || row.wT_Cut_Length },
                  { key: "unit_Conv_Name", label: "UNIT", align: "center", className: "text-gray-500 border-r border-gray-100 font-black text-[11px] uppercase tracking-widest" },
                  { key: "wt_12_FT", label: "WT/12 FT", align: "right", className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter", render: (val, row) => row.wt_12_FT || row.wT_12_FT },
                  { key: "final_CutLength_weight", label: "FINAL CUT LENGTH WT", align: "right", className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter" },
                  {
                    key: "pcs",
                    label: "PCS",
                    align: "right",
                    className: "border-r border-gray-100 w-28",
                    render: (val, row) => (
                      <span className="block px-2 py-1 font-medium text-right">
                        {row.pcs || row.pcs === 0 ? row.pcs : "-"}
                      </span>
                    )
                  },
                  {
                    key: "total_Weight",
                    label: "TOTAL WT",
                    align: "right",
                    className: "border-r border-gray-100 w-28",
                    render: (val, row) => (
                      <span className="block px-2 py-1 font-medium text-right">
                        {row.total_Weight || row.total_Weight === 0 ? row.total_Weight : "-"}
                      </span>
                    )
                  },
                  {
                    key: "actions",
                    label: "ACTIONS",
                    align: "center",
                    render: (val, row) => (
                      <button
                        onClick={() => handleEdit(row)}
                        className="px-2.5 py-1 border border-gray-200 text-blue-600 hover:bg-blue-50 transition-all text-[10px] font-black uppercase tracking-wider rounded-none"
                      >
                        Edit
                      </button>
                    )
                  }
                ]}
                data={isPackingData}
                showActions={false}
                tableClassName="text-[13px] border-none"
              />
            </div>
          )}
        </div>
      </div>

      {isModelOpen && formData && (
        <PackingForm
          initialData={selectedPackingData}
          onSave={handleSave}
          onCancel={() => setIsModelOpen(false)}
          isEditing={isEditing}
          filteredData={filteredData}
          formData={formData}
          setFormData={setFormData}
          isSaving={isSaving}
        />
      )}

      {errorModalOpen && (
        <ErrorModal
          message={errorMessage}
          subMessage={errorSubMessage}
          onClose={() => setErrorModalOpen(false)}
        />
      )}

      <div data-tour="packing-footer">
        <CalculationFooter
          items={[
            {
              label: "Total Units",
              value: isPackingData.reduce((sum, row) => sum + (Number(row.pcs) || 0), 0).toLocaleString(),
              suffix: "PCS"
            },
            {
              label: "Gross Weight",
              value: isPackingData.reduce((sum, row) => sum + (Number(row.total_Weight) || 0), 0).toFixed(3),
              suffix: "KG",
              color: "text-primary"
            }
          ]}
        />
      </div>

      <TourGuide
        isOpen={isTourOpen}
        steps={PackingTourSteps}
        title="Packing Guide"
        model="Packing Module"
        onClose={() => {
          setIsTourOpen(false);
          handleTourComplete();
        }}
      />
    </div>

  );
};

export default Packing;
